module.exports = __webpack_public_path__ + "static/media/39-2.3bb17ec2.mp3";